import authApi from '../apis/authApi';
import dataApi from '../apis/dataApi';

window.app = {
  api: {
    authApi,
    dataApi
  }
};
